module.exports = {render: function () {with(this){return _c('svg',{attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"#FFF","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M20 40a20 20 0 1 1 0-40 20 20 0 0 1 0 40zm0-5a15 15 0 1 0 0-30 15 15 0 0 0 0 30z","fill-opacity":".25"}}),_c('path',{attrs:{"d":"M10.98 2.15A19.92 19.92 0 0 1 20 0c3.25 0 6.31.77 9.02 2.15L26.95 6.7a14.93 14.93 0 0 0-13.9 0l-2.07-4.55z"}})])])}}};


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/spinner.svg?inline
// module id = 47
// module chunks = 3